import dayjs from 'dayjs';

export function formatDate(date: dayjs.ConfigType) {
  return date ? dayjs(date).format('YYYY-MM-DD') : '';
}

export function formatDatetime(date: dayjs.ConfigType) {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}
